<template>
    <section class="section-lophoc-teacher">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/lop-hoc">Lớp học</router-link></li>
                    <!-- <li>
                        <router-link v-if="ebooksClass&&ebooksClass.bookType&&ebooksClass.bookType.bookTypeId" :to="{ name: 'ebook-class', params: {id: ebooksClass.bookClass.classId, typeId: ebooksClass.bookType.bookTypeId} }" title="">
                        {{ebooksClass.bookType.name}}
                        </router-link>
                    </li> -->
                </ul>
            </div>
        </div>
        <div class="container">
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab title="Tổ chức lớp học" @click="handleChangeTab(1)" :active="tabIndex == 1"></b-tab>
                <b-tab title="Trang cá nhân" @click="handleChangeTab(2)" :active="tabIndex == 2"></b-tab>
            </b-tabs>
            <div class="tab" v-if="tabIndex == 1">
                <div class="pre-class-school-list__filter__action display-flex display-flex-space-between flex-wrap">
                    <div class="wrap-left display-flex">
                        <div class="row width-full">
                            <div class="col-md-12 col-lg-6">
                                <div class="item item__key input-custom-icon mt-1">
                                    <input v-model="paramQueryData.keyword" v-debounce="300" type="text"
                                        placeholder="Tìm kiếm lớp theo tên"
                                        class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                                    <i class="icon-search font-size-16 primary-color"></i>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <FilterCollapse @handleOnFilterCollapse="handleOnFilterCollapse" />
                            </div>
                        </div>
                        <!-- <a href="javascript:;" @click="toggleCollapseGroup"
                            class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                            :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                            Bộ lọc <i class="icon-arrow-down font-size-12"
                                :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                        </a> -->
                    </div>
                    <div class="wrap-right">
                        <a href="javascript:;"
                            class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                            @click="handleCreateOrUpdateClassSchool">
                            <img class="icon-plus" src="@/assets/img/plus.png" />
                            <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                            Tạo lớp học
                        </a>
                    </div>
                </div>
                <!-- <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
                    <FilterCollapse @handleOnFilterCollapse="handleOnFilterCollapse" />
                </b-collapse> -->
                <div class="class-school-list-item">
                    <div class="row" v-if="listDataClassSchool.length > 0">
                        <div class="col-md-4 col-sm-4" v-for="(item, index) of listDataClassSchool" :key="index">
                            <ItemClassSchool :type="1" :item="item" @handleEdit="handleEdit"
                                @handleDelete="handleDelete" @handleAddMember="handleAddMember" />
                        </div>
                    </div>
                    <div class="row" v-else>
                        Không có lớp học nào
                    </div>
                    <div class="row pagination container m-0">
                        <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                            :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
                    </div>
                </div>
            </div>
            <div class="tab" v-if="tabIndex == 2">
                <div class="pre-class-school-list__filter__action display-flex display-flex-space-between flex-wrap">
                    <div class="wrap-left display-flex">
                        <div class="row width-full">
                            <div class="col-md-12 col-lg-6">
                                <div class="item item__key input-custom-icon mt-1">
                                    <input v-model="paramQueryData.keyword" v-debounce="300" type="text"
                                        placeholder="Tìm kiếm lớp theo tên"
                                        class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                                    <i class="icon-search font-size-16 primary-color"></i>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <FilterCollapse @handleOnFilterCollapse="handleOnFilterCollapse" />
                            </div>
                        </div>
                        <!-- <a href="javascript:;" @click="toggleCollapseGroup"
                            class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                            :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                            Bộ lọc <i class="icon-arrow-down font-size-12"
                                :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                        </a> -->
                    </div>
                    <div class="wrap-right">
                    </div>
                </div>
                <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
                    <FilterCollapse @handleOnFilterCollapse="handleOnFilterCollapse" />
                </b-collapse>
                <div class="class-school-list-item">
                    <div class="row" v-if="listDataClassSchool.length > 0">
                        <div class="col-md-4 col-sm-4" v-for="(item, index) of listDataClassSchool" :key="index">
                            <ItemClassSchool :type="2" :item="item" @handleEdit="handleEdit"
                                @handleDelete="handleDelete" @handleAddMember="handleAddMember"
                                @handleSendDocument="handleSendDocument" :isPersonalPage="true" />
                        </div>
                    </div>
                    <div class="row" v-else>
                        Không có lớp học nào
                    </div>
                    <div class="row pagination container m-0">
                        <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                            :per-page="paramQueryData.pageSize" first-number last-number>
                        </b-pagination>
                    </div>
                </div>
            </div>
            <ModalDeleteClassSchool v-if="isShowModalDeleteClassSchool" :classSchoolId="classSchoolId"
                :name="nameClassSchoolSelected" @handleDeleteDone="handleDeleteDone" @closeModal="closeModalDelete" />
            <ModalCreateUpdateClassSchool v-if="isShowModalCreateUpdateClassSchool" :classSchoolId="classSchoolId"
                @handleDone="handleDone" @closeModal="closeModal" />
            <ModalAddMemberClassSchool v-if="isShowModalAddMemberClassSchool" :classSchoolId="classSchoolId"
                @handleDone="handleDoneAddMember" @closeModal="closeModalAddMember" />
            <ModalSendDocument v-if="isShowModalSendDocument" :classSchoolId="classSchoolId"
                @handleDone="handleDoneSendDocument" @closeModal="closeModalSendDocument" />
        </div>
    </section>
</template>

<script>
import ItemClassSchool from './../_components/ItemClassSchool.vue';
import ModalAddMemberClassSchool from './../_components/ModalAddMemberClassSchool.vue';
import ModalSendDocument from './../_components/ModalSendDocument.vue';
import ModalCreateUpdateClassSchool from './../_components/ModalCreateUpdateClassSchool.vue';
import debounce from "@/directives/debounce";
import FilterCollapse from './../_components/FilterCollapse.vue';
import { listClassSchool } from './../_api/classSchoolServices';
import ModalDeleteClassSchool from './../_components/ModalDeleteClassSchool.vue';
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";

export default {
    name: 'ClassSchool',
    directives: { debounce },
    components: {
        ItemClassSchool,
        ModalCreateUpdateClassSchool,
        FilterCollapse,
        ModalDeleteClassSchool,
        ModalAddMemberClassSchool,
        ModalSendDocument
    },
    watch: {
        'paramQueryData.pageIndex': 'getDataClassSchool',
        'paramQueryData.keyword': 'filterDataByKeyword'
    },
    data() {
        return {
            isShowModalCreateUpdateClassSchool: false,
            isShowModalDeleteClassSchool: false,
            isShowModalAddMemberClassSchool: false,
            isShowModalSendDocument: false,
            listDataClassSchool: [],
            classSchoolId: 0,
            tabIndex: 1,
            nameClassSchoolSelected: '',
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                subjectId: 0,
                classId: 0
            },
            totalRecords: 0,
            nameRouteExam: 'lop-hoc',
            openCollapseFilterGroup: false, //đóng mở bộ lọc
            authInfo: getAuth(),
            roleTeacher: ROLE_TEACHER,
            roleHocSinh: ROLE_PUPIL,
        }
    },
    mounted() {
        if (this.authInfo.roleCode == this.roleHocSinh) {
            this.$router.push('/danh-sach-lop-hoc')
        } else if (this.authInfo.roleCode == this.roleTeacher) {
            this.$router.push('/lop-hoc')
        } else {
            this.$router.push('/')
        }
        this.getDataClassSchool()

    },
    methods: {
        //đóng modal delete
        closeModalAddMember() {
            this.isShowModalAddMemberClassSchool = false
        },
        closeModalDelete() {
            this.isShowModalDeleteClassSchool = false
        },
        closeModal() {
            this.isShowModalCreateUpdateClassSchool = false
        },
        closeModalSendDocument() {
            this.isShowModalSendDocument = false
        },
        showModalAddMemberClassSchool() {
            this.isShowModalAddMemberClassSchool = true
        },
        showModalCreateOrUpdateClassSchool() {
            this.isShowModalCreateUpdateClassSchool = true
            //this.$refs.ModalCreateUpdateClassSchool.handleShowModal()
        },
        showModalDeleteClassSchool() {
            this.isShowModalDeleteClassSchool = true
            //this.$refs.ModalDeleteClassSchool.handleShowModal()
        },
        handleSendDocument(Id) {
            this.classSchoolId = Id
            this.isShowModalSendDocument = true
        },
        handleAddMember(Id) {
            this.classSchoolId = Id
            this.showModalAddMemberClassSchool()
        },
        handleEdit(Id) {
            this.classSchoolId = Id
            this.showModalCreateOrUpdateClassSchool()
        },
        handleDelete(data) {
            this.classSchoolId = data.id
            this.nameClassSchoolSelected = data.name
            this.showModalDeleteClassSchool()
        },
        handleCreateOrUpdateClassSchool() {
            this.classSchoolId = 0
            this.showModalCreateOrUpdateClassSchool()
        },
        toggleCollapseGroup() {
            this.openCollapseFilterGroup = !this.openCollapseFilterGroup
        },
        handleDeleteDone() {
            this.filterDataByKeyword()
        },
        handleDoneAddMember() {

        },
        handleDoneSendDocument() {

        },
        handleDone() {
            this.filterDataByKeyword()
        },
        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getDataClassSchool()
        },
        handleOnFilterCollapse(filter) {
            this.paramQueryData.subjectId = filter.subjectId
            this.paramQueryData.classId = filter.classId
            this.getDataClassSchool()
        },
        getDataClassSchool() {
            let self = this
            listClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
        handleChangeTab(tabIndex) {
            this.tabIndex = tabIndex
        }

    }
}
</script>

<style lang="scss" scoped>
.pagination {
    margin-bottom: 20px;
}

.filter-btn {
    line-height: 20px;
    margin-left: 20px;
}

.justify-content-between {
    justify-content: space-between;
}

.display-flex-space-between {
    justify-content: space-between;
}

.pre-class-school-list__filter__action {
    margin-top: 40px;
}

.class-school-list-item {
    margin-top: 10px;
}

// .class-school-list-item .row {
//     justify-content: center;
// }
.wrap-left {
    width: 80%;
}

.wrap-right {
    width: 20%;
    display: flex;
    justify-content: end;

    .item__add {
        width: 9rem;
        margin-top: 3px;
    }

    .icon-plus {
        width: 20px;
        top: 0px;
        display: inline-block;
    }
}

@media screen and (max-width: 1000px) {
    .wrap-left {
        width: 100%;
    }

    .wrap-right {
        width: 100%;
    }
}
</style>